/* 声明文件 */
import React from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import PubSub from 'pubsub-js'
import style from './index.module.scss'

export default function Statement() {
  const year = new Date().getFullYear()
  return (
    <div className="tw-text-common-gray tw-bg-white tw-text-12 lg:tw-text-14 tw-leading-22">
      <div className="tw-flex tw-flex-wrap tw-items-center">
        <p className="tw-mr-8">© {year} 懂车帝</p>
        <p>www.dongchedi.com</p>
      </div>
      <div className="tw-flex tw-flex-wrap tw-items-center">
        <p className="tw-mr-8">
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802026035"
            target="_blank"
            rel="nofollow"
          >
            <img
              src={require('static/gongan.png')}
              style={{
                width: 14,
                height: 14,
                marginBottom: '3px',
              }}
            />
            京公网安备 11010802026035号
          </a>
        </p>
        <p className="tw-mr-8">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">
            京ICP备17027026号-3
          </a>
        </p>
        <p>
          <a
            href="http://lf3-motor.dcarstatic.com/obj/ttfe/motor/pc/ICP.pdf"
            target="_blank"
            rel="nofollow"
          >
            增值电信业务经营许可证（京B2-20180202）
          </a>
        </p>
      </div>
      <div className="tw-flex tw-flex-wrap tw-items-center">
        <p className="tw-mr-8">
          <a
            href="http://lf3-motor.dcarstatic.com/obj/ttfe/motor/pc/radio-tv-License.pdf"
            target="_blank"
            rel="nofollow"
          >
            广播电视节目制作经营许可证
          </a>
        </p>
        <p className="tw-mr-8">网络文化经营许可证-京网文（2019）4715-493号</p>
        <p className="tw-mr-8">公司名称：北京空间变换科技有限公司</p>
      </div>
      <div className="tw-flex tw-flex-wrap tw-items-center">
        <p className="tw-mr-8">
          <a href="http://www.12377.cn/" target="_blank" rel="nofollow">
            中央网信办违法和不良信息举报中心
          </a>
        </p>
        <p>违法和不良信息举报电话：400-140-2108</p>
        <p>举报邮箱：jubao@mail.dongchedi.com</p>
      </div>
      <p>
        <a
          href="http://www.dongchediapp.com/cloud/page/agreement.html"
          target="_blank"
          rel="nofollow"
        >
          懂车帝用户协议
        </a>{' '}
        |{' '}
        <a
          href="https://is.snssdk.com/motor/inapp/basic_pages/privacy-policy.html"
          target="_blank"
          rel="nofollow"
        >
          懂车帝隐私政策
        </a>{' '}
        |{' '}
        <a
          href="http://lf3-motor.dcarstatic.com/obj/ttfe/motor/pc/business-License.pdf"
          target="_blank"
          rel="nofollow"
          className="tw-whitespace-nowrap"
        >
          营业执照
        </a>
      </p>
      <hr className="tw-my-12 tw-bg-common-cyan-blue tw-h-1" />
      <p
        className={`${style['more-info-list']} tw-text-common-black tw-text-12 lg:tw-text-14 tw-leading-12 lg:tw-leading-14`}
      >
        <a
          className="strong"
          href="/sitemap-pgc-A-1-1.html"
          target="_blank"
          onClick={() => {
            sendTeaCommEvent('clk_event', {
              event_id: 'related_module_bottom_link',
              module_id: 'related_module',
              button_name: '站点地图',
            })
          }}
        >
          站点地图
        </a>
        <a
          className="strong"
          href="https://www.toutiao.com/complain/"
          target="_blank"
          rel="nofollow"
          onClick={() => {
            sendTeaCommEvent('clk_event', {
              event_id: 'related_module_bottom_link',
              module_id: 'related_module',
              button_name: '侵权投诉',
            })
          }}
        >
          侵权投诉
        </a>
        <a
          className="strong"
          onClick={() => {
            PubSub.publish('OPEN_FEEDBACK')
            sendTeaCommEvent('clk_event', {
              event_id: 'related_module_bottom_link',
              module_id: 'related_module',
              button_name: '我要反馈',
            })
          }}
        >
          我要反馈
        </a>
        <a
          className="strong"
          href="https://bytedance.feishu.cn/docs/doccnZypAqwAcKkm1R48ciTpaUg#4WThtP"
          target="_blank"
          rel="nofollow"
          onClick={() => {
            sendTeaCommEvent('clk_event', {
              event_id: 'related_module_bottom_link',
              module_id: 'related_module',
              button_name: '加入我们',
            })
          }}
        >
          加入我们
        </a>
        <a
          className="strong"
          href="https://www.oceanengine.com/resource/dongchedi?source=dongchedi-pc"
          target="_blank"
          rel="nofollow"
          onClick={() => {
            sendTeaCommEvent('clk_event', {
              event_id: 'related_module_bottom_link',
              module_id: 'related_module',
              button_name: '广告投放',
            })
          }}
        >
          广告投放
        </a>
        <a
          className="strong"
          target="_blank"
          href="https://index.dongchedi.com"
          title="懂车指数"
        >
          懂车指数
        </a>
      </p>
    </div>
  )
}
